import type { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IApplicationVersionForListing } from '~/types/application-version'

import AppLogo from '~/components/AppLogo'
import { FASTLY_PATH } from '~/const/asset'
import { versionSemanticComparator } from '~/utils/comparators'
import { resize } from '~/utils/media'
import { dateColDef, textColDef } from '~/utils/table'

const TextCellRenderer = ({ value }: ICellRendererParams<IApplicationVersionForListing, string>): ReactElement => {
  return <span className="text">{value}</span>
}

const IconCellRenderer = ({ value }: ICellRendererParams<IApplicationVersionForListing>): ReactElement => {
  return <AppLogo appLogoUrl={value ? resize(`${FASTLY_PATH}${value}`, 170, 170) : ''} size="small" />
}

const LocalesCellRenderer = ({
  value,
}: ICellRendererParams<IApplicationVersionForListing, IApplicationVersionForListing['locales']>): ReactElement => {
  if (!value) {
    return <div />
  }

  return <div className="text">{value.length}</div>
}

const columns: ColDef[] = [
  {
    cellRenderer: IconCellRenderer,
    field: 'icon_file_id',
    headerName: '',
    headerTooltip: undefined,
    resizable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    width: 70,
  },
  textColDef(TextCellRenderer, {
    comparator: versionSemanticComparator,
    field: 'semantic_version',
    headerName: 'Version number',
    headerTooltip: undefined,
    menuTabs: [],
    minWidth: 200,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    tooltipField: undefined,
    width: 200,
  }),
  dateColDef({
    field: 'release_date',
    headerName: 'Date',
    headerTooltip: undefined,
    menuTabs: [],
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    valueGetter: ({ data }: ValueGetterParams<IApplicationVersionForListing, number>) =>
      data && data.release_date * 1000000,
    width: 140,
  }),
  textColDef(LocalesCellRenderer, {
    field: 'locales',
    headerName: 'Countries (languages)',
    headerTooltip: undefined,
    minWidth: 120,
    resizable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
    tooltipField: undefined,
    width: 120,
  }),
]

export default columns
